import type { ReactElement, ReactNode } from 'react'
import { Vector3 } from 'three'
import { Html } from '@react-three/drei'

/** Render Html scene labels above all other scene overlays (no distance-based z-index). */
const SCENE_LABEL_Z_INDEX_RANGE: [number, number] = [1, 1]

type Props = {
  position: Vector3
  highlighted: boolean
  showFloorplan: boolean
  onClick?: () => void
  children: ReactNode
}

/** Shared styled label chip used for support labels and check-position markers. */
const SceneLabelChip = ({
  position,
  highlighted,
  showFloorplan,
  onClick,
  children,
}: Props): ReactElement => (
  <Html
    position={position}
    center
    sprite
    distanceFactor={showFloorplan ? undefined : 6}
    zIndexRange={SCENE_LABEL_Z_INDEX_RANGE}
    occlude={false}
  >
    <div
      onClick={event => {
        event.stopPropagation()
        onClick?.()
      }}
      style={{
        fontSize: 12,
        lineHeight: '16px',
        fontWeight: 700,
        padding: '2px 6px',
        borderRadius: 6,
        background: highlighted ? '#1976d2' : 'rgba(255,255,255,0.92)',
        border: highlighted ? '1px solid #fff' : '1px solid rgba(0,0,0,0.65)',
        color: highlighted ? '#fff' : '#111',
        boxShadow: '0 1px 6px rgba(0,0,0,0.15)',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        cursor: onClick ? 'pointer' : 'default',
        pointerEvents: 'auto',
      }}
    >
      {children}
    </div>
  </Html>
)

export default SceneLabelChip
